import appAxios from "./axios";

class SupportService {
    async send(data) {
        const response = await appAxios.post(`/app/support`, data);
        return response
    }
}


const supportService = new SupportService()
export default supportService